import { render, staticRenderFns } from "./ColorCard.vue?vue&type=template&id=574f4075"
import script from "./ColorCard.vue?vue&type=script&lang=js"
export * from "./ColorCard.vue?vue&type=script&lang=js"
import style0 from "./ColorCard.vue?vue&type=style&index=0&id=574f4075&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports